import React from "react";
import { styled } from "@mui/material/styles";
import { SxProps, Theme } from "@mui/system";
import {
  TabsUnstyled,
  TabsListUnstyled,
  TabUnstyled,
  tabUnstyledClasses as tabClasses,
} from "@mui/base";
import { ButtonChoiceProps } from "./ButtonChoice.types";
import { colors } from "styles/colors";

const TabsStyled = styled(
  TabsUnstyled,
  { skipVariantsResolver: true }
)<{ sx?: SxProps<Theme> }>(({ sx }) => ({
  background: colors.lightGrey7,
  border: "2px solid #d6d7d9",
  borderRadius: "50px",
  display: "inline-block",
  overflow: "hidden",
  cursor: "pointer",
  ...sx,
}));

const TabListStyled = styled(
  TabsListUnstyled,
  { skipVariantsResolver: true }
)({
  height: "100%",
});

const TabStyled = styled(
  TabUnstyled,
  { skipVariantsResolver: true }
)<{ selectedColor: string; sx?: SxProps<Theme> }>(({ sx, selectedColor }) => ({
  height: "100%",
  borderRadius: "50px",
  border: 0,
  cursor: "pointer",
  fontWeight: 700,
  ...sx,
  [`&.${tabClasses.selected}`]: {
    backgroundColor: selectedColor,
    color: "white",
  },
}));

// Generic component
export default function ButtonChoice<T extends number | string = number>({
  value,
  options,
  handleChange,
  selectedColor = colors.buttonChoiceBlue,
  size = "medium",
}: ButtonChoiceProps<T>): JSX.Element {
  const sizes = {
    small: {
      tabsStyled: { height: "28px" },
      tabStyled: { paddingLeft: "10px", paddingRight: "10px" },
    },
    medium: {
      tabsStyled: { height: "34px" },
      tabStyled: { paddingLeft: "16px", paddingRight: "16px" },
    },
  };

  return (
    <TabsStyled
      value={value}
      onChange={(_, val) => handleChange(val as T)}
      sx={sizes[size].tabsStyled}
    >
      <TabListStyled>
        {options.map(({ label }, idx) => (
          <TabStyled
            key={`${label}-${idx}`}
            selectedColor={selectedColor}
            sx={sizes[size].tabStyled}
          >
            {label}
          </TabStyled>
        ))}
      </TabListStyled>
    </TabsStyled>
  );
}
